module.exports = __webpack_public_path__ + "static/img/aniImg.f2eeb614.png";